import { EChartsCoreOption } from 'echarts/core';

export class ChartBuilder {
  protected options: EChartsCoreOption = {
    tooltip: {},
  };

  public setTitle(text: string): ChartBuilder {
    this.options['title'] = {
      ...((this.options['title'] as object) ?? {}),
      text,
      left: 'center',
      top: 'top',
      padding: 20,
    };
    return this;
  }

  public setSubtitle(subtext: string): ChartBuilder {
    this.options['title'] = {
      ...((this.options['title'] as object) ?? {}),
      subtext,
      itemGap: 5,
    };
    return this;
  }

  public merge(options: EChartsCoreOption): ChartBuilder {
    this.options = { ...this.options, ...options };
    return this;
  }

  public build(): EChartsCoreOption {
    return this.options;
  }
}
